import { Field, Formik } from 'formik';
import { Box, Button, Card, Stack } from '@mui/material';
import { SwitchField } from 'shared/ui/formik-fields/switch-field';
import { ErrorBanner } from 'shared/ui/error-banner';
import { LoadingBanner } from 'shared/ui/loading-banner';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { useSnack } from 'shared/ui/snack';
import { formTools, FormData } from './service-functions.form-tools';
import { useServiceFunctionsSettings } from './use-service-functions-settings.hook';

export const ServiceFunctionsForm = () => {
  const { data, isLoading, error, update } = useServiceFunctionsSettings();
  const { showError, showSuccess } = useSnack();

  const handleSubmit = async (values: FormData) => {
    await update(formTools.toCreateDto(values))
      .then(() => showSuccess('Настройки обновлены'))
      .catch((e: unknown) => showError(`Ошибка обновления настроек: ${extractNestJsErrorMessage(e)}`));
  };

  if (isLoading) return <LoadingBanner />;
  if (error) return <ErrorBanner errorMessage={extractNestJsErrorMessage(error)} />;

  return (
    <Formik initialValues={data ? formTools.fromDto(data) : formTools.emptyValues()} onSubmit={handleSubmit} validate={formTools.validate}>
      {({ submitForm, dirty, isValid }) => (
        <Card sx={{ p: 2, maxWidth: 720 }}>
          <Stack direction="column" spacing={2}>
            <Field
              name="createPayOrdersFromPurchases"
              label="Формировать платежки из заявок"
              type="checkbox"
              component={SwitchField}
            />
            <Box display="flex" justifyContent="flex-end">
              <Button variant="contained" color="primary" size="small" onClick={submitForm} disabled={!dirty || !isValid}>
                Сохранить
              </Button>
            </Box>
          </Stack>
        </Card>
      )}
    </Formik>
  );
};
